/**
 * Returns the display name for a given brand.
 *
 * @param brand - The brand identifier from Content.Properties.Brand.
 * @returns The display name for the brand.
 *
 * - 'golf' returns 'Bravo Golf'
 * - 'safari' returns 'Bravo Safari'
 * - 'rejseklubben' returns 'Rejseklubben'
 * - Any other value returns 'Bravo Tours'
 */

export const getBrandName = (brand: Content.Properties.Brand): string => {
  switch (brand) {
    case 'golf':
      return 'Bravo Golf';

    case 'safari':
      return 'Bravo Safari';

    case 'rejseklubben':
      return 'Rejseklubben';

    default:
      return 'Bravo Tours';
  }
};
